import Swal from "sweetalert2";

export function noPermissionAlert() {
  Swal.fire(
    "",
    "Your profile under review, please try after profile approve.",
    "warning"
  );
  return false;
}

export function waringMessage(msg) {
  Swal.fire("", "Please login first to " + msg + ".", "warning");
  return false;
}

export function error(msg) {
  Swal.fire("", msg, "error");
  return false;
}

export function success(msg) {
  Swal.fire("", msg, "success");
  return false;
}
